import bulkImportExcelRequest from 'utils/bulkImportExcelRequest'
import bulkImportShapeFileRequest from 'utils/bulkImportShapeFileRequest'
import { generateApiKey, fetchUserApiKeys, deleteApiKey } from 'api/user'

const bulkImportPath = '/api/bulk-import'

async function getApiKey() {
  const response = await fetchUserApiKeys()
  if (response && response.apiKey) {
    return response.apiKey
  } else {
    const response = await generateApiKey()
    if (response && response.apiKey) {
      return response.apiKey
    }
  }
}

export const requestUploadBulkImportExcel = async (data, isReassessmentsAllowed = false, ignoreExistingHabitats = false) => {
  const apiKey = await getApiKey()

  return bulkImportExcelRequest(`${bulkImportPath}/upload-excel`, data, apiKey, isReassessmentsAllowed, ignoreExistingHabitats, undefined)
}

export const requestUploadBulkImportShapeFile = async (data) => {
  const apiKey = await getApiKey()

  return bulkImportShapeFileRequest(`${bulkImportPath}/upload-shape-file`, data, apiKey)
}
